import { httpClient } from '../http-client';
import { Role } from './role.types';

export const getRole = async (): Promise<Role> => {
	const { data } = await httpClient.get<Role>(`/role`);

	return data;
};
